export enum DriverSettlementMethod {
  DAILY_RATE = 'daily-rate',
  MILEAGE_RATE = 'mileage-rate',
  BASE_PLUS_PERCENTAGE = 'base-plus-percentage',
  ROUND_TRIP_RATE = 'round-trip',
}
